<div *ngIf="globalsService.isLinkExpired()" [innerHtml]="globalsService.getLinkExpiredHtml() | safe: 'html'"></div>
<div>
  <ngx-loading [show]="loading" aria-live="polite" aria-label='Loading'></ngx-loading>
  <!--App Component -->
</div>
<div *ngIf="globalsService.getResetPasswordToken() != null" style="width: 100%;">
  <app-resetpassword></app-resetpassword>
</div>
<router-outlet *ngIf="isDashboardEmbed"></router-outlet>
<div *ngIf="!isDashboardEmbed && globalsService.getShowLogin() === true" style="width: 100%;">
  <app-debug></app-debug>
  <app-login></app-login>
</div>
<mat-sidenav-container *ngIf="!isDashboardEmbed && globalsService.getOwnerID() != null" fullscreen>
  <mat-sidenav [ngClass]="getSidenavClass()" #drawer mode="side" [opened]="showSideNav()">
    <!--<div class="owner-role">{{globalsService.getLoggedInOwnerRoleName()}}</div>-->
    <ng-container *ngIf="globalsService.isAdminUILogin()">
          <div class="owner-designerID">{{globalsService.getOwnerDesignerID()}}</div>
    </ng-container>
    <ng-container *ngIf="globalsService.isAdminUILogin() || globalsService.isSimple()">
      <div class="owner-name">{{globalsService.getLoggedInOwnerName()}}</div>
      <button *ngFor="let feature of appService.getSectionFeatures('User')" mat-raised-button
        [color]="getColor(feature.routerLink, feature.queryParams)" class="button-menu mat-elevation-z0"
        [routerLink]="feature.routerLink" [queryParams]="getQueryParams(feature)"
        (click)="setActiveLink(feature.routerLink, feature.queryParams)">{{globalsService.termTranslate(feature.name)}}</button>
      <mat-divider *ngIf="globalsService.isAdminUILogin()"></mat-divider>
      <mat-expansion-panel *ngIf="globalsService.isAdminUILogin()" class="mat-elevation-z0">
        <mat-expansion-panel-header class="menu-section-header">
          Data
        </mat-expansion-panel-header>
        <button *ngFor="let feature of appService.getSectionFeatures('Data')" mat-raised-button
          [color]="getColor(feature.routerLink, feature.queryParams)" class="button-menu mat-elevation-z0"
          [routerLink]="feature.routerLink" [queryParams]="getQueryParams(feature)"
          (click)="setActiveLink(feature.routerLink, feature.queryParams)">{{globalsService.termTranslate(feature.name)}}</button>
      </mat-expansion-panel>
      <mat-divider></mat-divider>
      <button *ngIf="globalsService.isAdminUILogin()" mat-raised-button class="button-menu mat-elevation-z0"
        (click)="globalsService.logoutUI()">Logout</button>
      <mat-divider></mat-divider>
      <div *ngIf="globalsService.isAllowDebug()" style="padding: 16px;">
        <mat-checkbox [(checked)]="globalsService.debug" [(ngModel)]="globalsService.debug" name="cbDebug">Debug Mode
        </mat-checkbox>
      </div>
    </ng-container>
  </mat-sidenav>
  <mat-sidenav-content>
    <app-debug></app-debug>
    <div
      *ngIf="(globalsService.isSimple() && globalsService.getDatasetExternalID() == null) || !globalsService.getHideMenu()"
      style="cursor: pointer; width: 36px; padding: 3px;">
      <mat-icon matTooltip="Show Menu" *ngIf="drawer.opened == false && showSideNav()"
        style="cursor: pointer; font-size: 24px;" fontSet="fa" fontIcon="fa-angle-double-right"
        (click)="drawer.toggle()"></mat-icon>
      <mat-icon matTooltip="Hide Menu" *ngIf="drawer.opened == true" style="cursor: pointer; font-size: 24px;"
        fontSet="fa" fontIcon="fa-angle-double-left" (click)="drawer.toggle()"></mat-icon>
    </div>
    <nav mat-tab-nav-bar
      *ngIf="appService.getSectionFeatures('User').length > 0 && globalsService.getCCSFrom() === 'designer' && !globalsService.isSimple()">
      <a mat-tab-link *ngFor="let feature of appService.getSectionFeatures('User')" [routerLink]="feature.routerLink"
        [queryParams]="getQueryParams(feature)" (click)="setActiveLink(feature.routerLink, feature.queryParams)"
        [active]="isActiveLink(feature.routerLink)">{{globalsService.termTranslate(feature.name)}}
      </a>
      <div mat-tab-link *ngIf="globalsService.isAllowDebug()">
        <mat-checkbox [(checked)]="globalsService.debug" [(ngModel)]="globalsService.debug" name="cbDebug">Debug
          Mode</mat-checkbox>
      </div>
    </nav>
    <ng-container *ngIf="globalsService.isSimple() && this.globalsService.getCurrentURL().indexOf('/login') > -1">
      <div [innerHtml]="templateService.getTemplateHtmlByCode('SSDLP') | safe: 'html'">
        <!--Simple Survey Designer landing page HTML goes here!--></div>
    </ng-container>
    <router-outlet
      *ngIf="!globalsService.getLinkRequiresPassword() && !globalsService.isLinkExpired() && globalsService.getOwnerID() && !globalsService.getMaintenance()"></router-outlet>
    <div
      *ngIf="globalsService.getLinkRequiresPassword() && !globalsService.isLinkExpired() && !globalsService.getMaintenance()"
      [innerHtml]="globalsService.getPasswordEntryHtml() | safe: 'html'"></div>
    <div class="border d-flex align-items-center justify-content-center h-100" *ngIf="globalsService.getMaintenance()"
      [innerHtml]="globalsService.getMaintenanceHtml()"></div>
  </mat-sidenav-content>
</mat-sidenav-container>
